/**
 * Routes where session replay must not run (docs/ascension-plan.md §5.5).
 * These path prefixes are the single source of truth shared with the PostHog
 * SDK URL blocklist in `posthog.ts`.
 */
export const BLOCKED_REPLAY_PATH_PREFIXES = [
  "/checkout",
  "/admin",
  "/dashboard/settings",
] as const;

export function isSessionRecordingBlockedPath(pathname: string): boolean {
  return BLOCKED_REPLAY_PATH_PREFIXES.some((prefix) =>
    pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}
